import React from 'react';
import classNames from 'classnames';

import styles from './Toggle.module.scss';

export const toggleSizes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
};

export const ToggleComponent = ({
  checked,
  onChange,
  disabled,
  size = toggleSizes.md,
  id,
  className,
}) => {
  const toggleClass = classNames(
    styles.toggle,
    {
      [styles[`toggle_size_${size}`]]: size,
      [styles.checked]: checked,
      [styles.disabled]: disabled,
    },
    className
  );
  return (
    <label className={toggleClass}>
      <input
        type="checkbox"
        checked={!!checked}
        disabled={disabled}
        id={id}
        onChange={disabled ? () => null : () => onChange?.(!checked)}
      />
      <span className={styles.track}>
        <span className={styles.thumb} />
      </span>
    </label>
  );
};

ToggleComponent.displayName = 'Toggle';
